import React from "react";
import IconComponent from "../../aGlobalDesign/Icons/IconComponent";

const TagChip = ({ tagName, onDelete, onSelect, selected }) => {
    return (
        <button className={"tagchipcontainer " + (selected ? "tagchipcontainer-selected" : "")}
            style={{ cursor: onSelect ? "pointer" : "default" }}
            onClick={ onSelect ? () => onSelect() : null }
        >
            <div>{tagName}</div>
            { onDelete ?
                <div onClick={() => onDelete()} style={{ cursor: "pointer" }}>
                    <IconComponent dimensions="18" nameIcon="closeChip" color={"carbone"} />
                </div> : null
            }
        </button>
    );
};

export default TagChip;
